import apisauce from "apisauce"
import AppConfig from "../../configs/AppConfig"

const create = (baseURL = AppConfig.sagaUrl) => {
  const api = apisauce.create({
    // base URL is read from the "constructor"
    baseURL,
    // here are some default headers
    headers: {
      "Cache-Control": "no-cache",
      "Access-Control-Allow-Origin": "*"
    },
    // 10 second timeout...
    timeout: 30000
  })

  // Force OpenWeather API Key on all requests
  // tslint:disable-next-line
  api.addRequestTransform(request => {})
  const requestGetHisobusHomePage = () => api.get(`/Home/Home`)
  const requestGetHisobusBlogPage = () => api.get(`/Blog/GetBlogContent`)
  const requestGetHisobusBlogDetailPage = (id: number) =>
    api.get(`/Blog/GetBlogDetail/${id}`)
  const requestLogin = (email: string, password: string) =>
    api.post(`/Account/Login/`, { email, password })
  const requestUserProfile = jwtToken =>
    api.get("/Account/GetUserProfile", null, {
      headers: {
        Authorization: `Bearer ${jwtToken}`
      }
    })
  const requestExternalLogin = data => api.post("/Account/ExternalLogin", data)
  const requestRegister = data => api.post("/Account/Register", data)
  const requestConfirmEmail = (userId, token) =>
    api.get(
      `/Account/ConfirmEmail?userId=${userId}&code=${encodeURIComponent(
        token
      )}`,
      null
    )
  const requestGetInitialBooking = () => api.get(`/Booking/GetInitialBooking`)
  const requestGetInitialBookingDetail = bookingDetail =>
    api.post(`/Booking/GetInitialBookingDetail`, bookingDetail)
  const requestCreateBooking = (
    jwtToken,
    culture,
    bookingTrip,
    routeItems,
    selectedBusTypes,
    userId
  ) =>
    api.post(
      `/Booking/CreateBooking?culture=${culture}`,
      {
        bookingTrip,
        routeItems,
        selectedBusTypes,
        userId
      },
      {
        headers: {
          Authorization: `Bearer ${jwtToken}`
        }
      }
    )
  const requestUpdateBooking = (
    jwtToken,
    culture,
    bookingTrip,
    routeItems,
    selectedBusTypes,
    userId
  ) =>
    api.put(
      `/Booking/UpdateBooking?culture=${culture}`,
      {
        bookingTrip,
        routeItems,
        selectedBusTypes,
        userId
      },
      {
        headers: {
          Authorization: `Bearer ${jwtToken}`
        }
      }
    )
  const requestGetBookingDetail = (jwtToken, id, userId) =>
    api.get(`/Booking/GetBookingDetail?id=${id}&userId=${userId}`, null, {
      headers: {
        Authorization: `Bearer ${jwtToken}`
      }
    })
  const requestGetPaymentDetail = (jwtToken, culture, id, userId) =>
    api.get(
      `/Booking/GetPaymentDetail?id=${id}&userId=${userId}&culture=${culture}`,
      null,
      {
        headers: {
          Authorization: `Bearer ${jwtToken}`
        }
      }
    )
  const requestGetQuotationDetail = (jwtToken, id, culture) =>
    api.get(`/Booking/GetQuotationDetail?id=${id}&culture=${culture}`, null, {
      headers: {
        Authorization: `Bearer ${jwtToken}`
      }
    })
  const requestGetHisobusMybooking = (jwtToken, userId) =>
    api.get(`/MyBooking/MyBooking?userId=${userId}`, null, {
      headers: {
        Authorization: `Bearer ${jwtToken}`
      }
    })
  const requestCreateHisobusContact = contact =>
    api.post("/Contact/CreateContact", contact)
  const requestSendQuotation = (jwtToken, userId, id, culture) =>
    api.post(
      `/Booking/GetQuotation?userId=${userId}&id=${id}&culture=${culture}`,
      [],
      {
        headers: {
          Authorization: `Bearer ${jwtToken}`
        }
      }
    )
  const requestUpdateUserProfile = (jwtToken, userProfile) =>
    api.post("/Account/UpdateUserProfile", userProfile, {
      headers: {
        Authorization: `Bearer ${jwtToken}`
      }
    })
  const requestUpdateMyBookingTransaction = (jwtToken, bookingTransaction) =>
    api.post(`/MyBooking/UpdateMyBookingTransaction`, bookingTransaction, {
      headers: {
        Authorization: `Bearer ${jwtToken}`
      }
    })
  const requestResetUserPassword = (email, culture) =>
    api.post(`/Account/ForgotPassword?culture=${culture}`, { email }, null)

  const requestConfirmResetUserPassword = confirmData =>
    api.post("/Account/ResetPassword", confirmData, null)

  const requestCreatePartnerRequest = request =>
    api.post("/PartnerRequest/CreateRequest", request, null)

  const requestCreateBusinessRegister = business =>
    api.post("/BusinessRegister/CreateRegister", business, null)

  const requestGetProvinces = () => api.get("/GeoLocation/GetProvinces")

  const requestGetDistrictByProvinceId = ProvinceId =>
    api.get("/GeoLocation/GetDistrictsByProvinceId?id=" + ProvinceId)

  const requestGetSubDistrictByDistrictId = DistrictId =>
    api.get("/GeoLocation/GetSubDistrictsByDistrictId?id=" + DistrictId)

  const requestGetPriceCompare = bookingDetail => {
    api.post("/Booking/GetPriceCompare", bookingDetail)
  }

  const requestCreateBookingV2 = (jwtToken, booking) =>
    api.post("/Booking/CreateBookingV2", booking, {
      headers: {
        Authorization: `Bearer ${jwtToken}`
      }
    })

  const requestCheckBookingPrice = (jwtToken, userId, bookingId) =>
    api.get(`/GBPay/PreRequest?userId=${userId}&bookingId=${bookingId}`, null, {
      headers: {
        Authorization: `Bearer ${jwtToken}`
      }
    })

  const requestGetPaymentToken = (appKey, tokenRequest) =>
    api.post("https://api.gbprimepay.com/v1/tokens", tokenRequest, {
      headers: {
        Authorization: `Basic ${appKey}`
      }
    })

  const requestChargePayment = (app2Key, chargeRequest) =>
    api.post("https://api.gbprimepay.com/v1/tokens/charge", chargeRequest, {
      headers: {
        Authorization: `Basic ${app2Key}`
      }
    })

  const request3DSecure = data =>
    api.post("https://api.gbprimepay.com/v1/tokens/3d_secured", data, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    })

  const requestGetPromotionByPromoCode = (jwtToken, code) =>
    api.get(`/Backend/Promotion/GetPromotionByPromoCode?code=${code}`, null, {
      headers: {
        Authorization: `Bearer ${jwtToken}`
      }
    })
  const requestCustomerRegister = (customerReg, culture) =>
    api.post(`/Account/RegisterV2?culture=${culture}`, customerReg, null)

  const requestUpdateCustomerProfile = (jwtToken, customerProfileReq) =>
    api.post("/Account/UpdateUserProfileV2", customerProfileReq, {
      headers: {
        Authorization: `Bearer ${jwtToken}`
      }
    })
  const requestGetAssuerInfo = (bookingId, refId) =>
    api.get(`/assurer/GetAssuerInfo/${bookingId}?refId=${refId}`, null, null)

  const requestCreateAssuer = assurerReq =>
    api.post(`/Assurer/CreateAssuer`, assurerReq, null)

  const requestGetTripObjects = jwtToken =>
    api.get(`/TripObjective/GetTripObjects`, null, {
      headers: {
        Authorization: `Bearer ${jwtToken}`
      }
    })
  const requestGetAssurerGets = (jwtToken, bookingNo) =>
    api.get(`/Assurer/Gets?bookingNo=${bookingNo}`, null, {
      headers: {
        Authorization: `Bearer ${jwtToken}`
      }
    })

  const requestDeleteAssurerGets = (jwtToken, id, bookingId) =>
    api.delete(`/Assurer/Delete/${id}?bookingId=${bookingId}`, null, {
      headers: {
        Authorization: `Bearer ${jwtToken}`
      }
    })

  const requestGetCountries = jwtToken =>
    api.get(`/Country/GetCountries`, null, {
      headers: {
        Authorization: `Bearer ${jwtToken}`
      }
    })

  const requestCreateEmployee = employeeReq =>
    api.post(`/EmployeeRentRequest/CreateEmployeeRentReques`, employeeReq, null)

  return {
    requestGetHisobusHomePage,
    requestGetHisobusBlogPage,
    requestGetHisobusBlogDetailPage,
    requestLogin,
    requestUserProfile,
    requestExternalLogin,
    requestRegister,
    requestConfirmEmail,
    requestGetInitialBooking,
    requestGetInitialBookingDetail,
    requestCreateBooking,
    requestUpdateBooking,
    requestGetBookingDetail,
    requestGetPaymentDetail,
    requestGetQuotationDetail,
    requestCreateHisobusContact,
    requestGetHisobusMybooking,
    requestSendQuotation,
    requestUpdateUserProfile,
    requestUpdateMyBookingTransaction,
    requestResetUserPassword,
    requestConfirmResetUserPassword,
    requestCreatePartnerRequest,
    requestCreateBusinessRegister,
    requestGetProvinces,
    requestGetDistrictByProvinceId,
    requestGetSubDistrictByDistrictId,
    requestGetPriceCompare,
    requestCreateBookingV2,
    requestCheckBookingPrice,
    requestGetPaymentToken,
    requestChargePayment,
    request3DSecure,
    requestGetPromotionByPromoCode,
    requestCustomerRegister,
    requestUpdateCustomerProfile,
    requestGetAssuerInfo,
    requestCreateAssuer,
    requestGetTripObjects,
    requestGetAssurerGets,
    requestDeleteAssurerGets,
    requestGetCountries,
    requestCreateEmployee
  }
}

export default create()



// WEBPACK FOOTER //
// ./src/helpers/sagaApi/sagaApi.ts